import React from 'react';
import styles from './progressStepper.module.css';

interface ProgressStepperProps {
  step: number;
  height: number;
  isNumberOnTop?: boolean;
}

export default function ProgressStepper({ step, height, isNumberOnTop = false }: ProgressStepperProps) {
  return (
    <div className={styles.stepperContainer}>
      <div className={styles.stepperWrapper} style={{ height }}>
        {!isNumberOnTop && <div className={styles.dashedLineTop} />}
        <div className={styles.stepIndicator}>{step}</div>
        <div className={styles.dashedLineBottom} />
      </div>
    </div>
  );
}
